import request from '@/utils/request'

let Ma_organizationApi = {

  /*组织列表*/
  list(data) {
    return request._post('/shop/plus.ma_organization.Index/index', data);
},
/*添加组织*/
add(data) {
    return request._post('/shop/plus.ma_organization.Index/add', data);
},
/*修改组织*/
edit(data) {
    return request._post('/shop/plus.ma_organization.Index/edit', data);
},
/*删除组织*/
del(data) {
    return request._post('/shop/plus.ma_organization.Index/del', data);
},
/*组织详情*/
detail(data) {
  return request._post('/shop/plus.ma_organization.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_organization.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_organization.Setting/getSetting', data, errorback);
    },

    importData(data) {
        return request._post('/shop/plus.ma_organization.Index/import', data);
    },
    exportExcel(data) {
        return request._post('/shop/plus.ma_organization.Index/export', data);
    },
}
export default Ma_organizationApi;



// WEBPACK FOOTER //
// ./src/api/ma_organization.js